<template>
    <div class="container">
        <div v-show="!isLoading">
            <h1>{{ $t("edit-your-profile") }}</h1>

            <form
                class="form form--signup"
                action="#"
                @submit.prevent="submitForm">

                <div class="grid">
                    <div class="grid__item desktop--4">
                        <div
                            class="field field--text">
                            <label
                                class="field__label field--text__label"
                                for="field-pseudo">{{ $t("pseudonym") }}</label>
                            <input
                                required
                                name="pseudo"
                                v-model="pseudo"
                                id="field-pseudo"
                                :data-label="$t('pseudonym')"
                                class="field__input field--text__input"
                                :class="(error.errors !== undefined && error.errors['pseudo'] !== undefined && error.errors['pseudo'].length > 0) ? 'field__input--error': ''"
                                type="text"
                            />
                            <p
                                id="field-error-pseudo"
                                v-if="error.errors !== undefined && error.errors['pseudo'] !== undefined && error.errors['pseudo'].length > 0"
                                class="field__message--error"
                            >
                                {{ error.errors['pseudo'][0] }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="grid__item desktop--4">
                        <div
                            class="field field--text">
                            <label
                                class="field__label field--text__label"
                                for="field-birthplace">{{ $t("place-of-birth") }}</label>

                            <LocationAutocomplete
                                id="field-birthplace"
                                @change="updateLocation"
                                :selected-location="`${birthcity}, ${birthcountry}`"
                                :is-valid="(error.errors !== undefined && error.errors['birthcity'] !== undefined && error.errors['birthcity'].length > 0) ? false : true"></LocationAutocomplete>
                            <p
                                id="field-error-birthcity"
                                v-if="error.errors !== undefined && error.errors['birthcity'] !== undefined && error.errors['birthcity'].length > 0"
                                class="field__message--error"
                            >
                                {{ error.errors['birthcity'][0] }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="grid__item desktop--4">
                        <div class="field">
                            <label class="field__label">{{ $t("birthdate") }}</label>
                            <div class="field--select-group">
                                <field-select
                                    :required="true"
                                    :value="birthdateDay"
                                    name="birthdateDay"
                                    id="field-birthdate-day"
                                    input-label-id="field-birthdate-day-label"
                                    @update-value="updateBirthdateDay"
                                    :options="[
                                        {'value': '01', 'label': '1'},
                                        {'value': '02', 'label': '2'},
                                        {'value': '03', 'label': '3'},
                                        {'value': '04', 'label': '4'},
                                        {'value': '05', 'label': '5'},
                                        {'value': '06', 'label': '6'},
                                        {'value': '07', 'label': '7'},
                                        {'value': '08', 'label': '8'},
                                        {'value': '09', 'label': '9'},
                                        {'value': '10', 'label': '10'},
                                        {'value': '11', 'label': '11'},
                                        {'value': '12', 'label': '12'},
                                        {'value': '13', 'label': '13'},
                                        {'value': '14', 'label': '14'},
                                        {'value': '15', 'label': '15'},
                                        {'value': '16', 'label': '16'},
                                        {'value': '17', 'label': '17'},
                                        {'value': '18', 'label': '18'},
                                        {'value': '19', 'label': '19'},
                                        {'value': '20', 'label': '20'},
                                        {'value': '21', 'label': '21'},
                                        {'value': '22', 'label': '22'},
                                        {'value': '23', 'label': '23'},
                                        {'value': '24', 'label': '24'},
                                        {'value': '25', 'label': '25'},
                                        {'value': '26', 'label': '26'},
                                        {'value': '27', 'label': '27'},
                                        {'value': '28', 'label': '28'},
                                        {'value': '29', 'label': '29'},
                                        {'value': '30', 'label': '30'},
                                        {'value': '31', 'label': '31'},
                                    ]" />
                                <field-select
                                    :required="true"
                                    :value="birthdateMonth"
                                    name="birthdateMonth"
                                    id="field-birthdate-month"
                                    input-label-id="field-birthdate-month-label"
                                    @update-value="updateBirthdateMonth"
                                    :options="[
                                        {'value': '01', 'label': '1'},
                                        {'value': '02', 'label': '2'},
                                        {'value': '03', 'label': '3'},
                                        {'value': '04', 'label': '4'},
                                        {'value': '05', 'label': '5'},
                                        {'value': '06', 'label': '6'},
                                        {'value': '07', 'label': '7'},
                                        {'value': '08', 'label': '8'},
                                        {'value': '09', 'label': '9'},
                                        {'value': '10', 'label': '10'},
                                        {'value': '11', 'label': '11'},
                                        {'value': '12', 'label': '12'},
                                    ]" />
                                <field-select
                                    :required="true"
                                    name="birthdateYear"
                                    :value="birthdateYear"
                                    id="field-birthdate-year"
                                    input-label-id="field-birthdate-year-label"
                                    @update-value="updateBirthdateYear"
                                    :options="years" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid desktop--vertical--centered">
                    <div class="grid__item desktop--4">
                        <div class="field field--birthtime">
                            <label class="field__label">{{ $t("birthtime-precise") }}</label>
                            <div class="field--select-group">
                                <field-select
                                    :required="true"
                                    :value="birthtimeHour"
                                    name="birthtimeHour"
                                    id="field-birthtime-hour"
                                    input-label-id="field-birthtime-hour-label"
                                    @update-value="updateBirthtimeHour"
                                    :options="[
                                        {'value': '00', 'label': '0 heure'},
                                        {'value': '01', 'label': '1 heure'},
                                        {'value': '02', 'label': '2 heures'},
                                        {'value': '03', 'label': '3 heures'},
                                        {'value': '04', 'label': '4 heures'},
                                        {'value': '05', 'label': '5 heures'},
                                        {'value': '06', 'label': '6 heures'},
                                        {'value': '07', 'label': '7 heures'},
                                        {'value': '08', 'label': '8 heures'},
                                        {'value': '09', 'label': '9 heures'},
                                        {'value': '10', 'label': '10 heures'},
                                        {'value': '11', 'label': '11 heures'},
                                        {'value': '12', 'label': '12 heures'},
                                        {'value': '13', 'label': '13 heures'},
                                        {'value': '14', 'label': '14 heures'},
                                        {'value': '15', 'label': '15 heures'},
                                        {'value': '16', 'label': '16 heures'},
                                        {'value': '17', 'label': '17 heures'},
                                        {'value': '18', 'label': '18 heures'},
                                        {'value': '19', 'label': '19 heures'},
                                        {'value': '20', 'label': '20 heures'},
                                        {'value': '21', 'label': '21 heures'},
                                        {'value': '22', 'label': '22 heures'},
                                        {'value': '23', 'label': '23 heures'}
                                    ]" />
                                <field-select
                                    :required="true"
                                    name="birthtimeMinute"
                                    :value="birthtimeMinute"
                                    id="field-birthtime-minute"
                                    input-label-id="field-birthtime-minute-label"
                                    @update-value="updateBirthtimeMinute"
                                    :options="[
                                        {'value': '00', 'label': '0 min.'},
                                        {'value': '01', 'label': '1 min.'},
                                        {'value': '02', 'label': '2 min.'},
                                        {'value': '03', 'label': '3 min.'},
                                        {'value': '04', 'label': '4 min.'},
                                        {'value': '05', 'label': '5 min.'},
                                        {'value': '06', 'label': '6 min.'},
                                        {'value': '07', 'label': '7 min.'},
                                        {'value': '08', 'label': '8 min.'},
                                        {'value': '09', 'label': '9 min.'},
                                        {'value': '10', 'label': '10 min.'},
                                        {'value': '11', 'label': '11 min.'},
                                        {'value': '12', 'label': '12 min.'},
                                        {'value': '13', 'label': '13 min.'},
                                        {'value': '14', 'label': '14 min.'},
                                        {'value': '15', 'label': '15 min.'},
                                        {'value': '16', 'label': '16 min.'},
                                        {'value': '17', 'label': '17 min.'},
                                        {'value': '18', 'label': '18 min.'},
                                        {'value': '19', 'label': '19 min.'},
                                        {'value': '20', 'label': '20 min.'},
                                        {'value': '21', 'label': '21 min.'},
                                        {'value': '22', 'label': '22 min.'},
                                        {'value': '23', 'label': '23 min.'},
                                        {'value': '24', 'label': '24 min.'},
                                        {'value': '25', 'label': '25 min.'},
                                        {'value': '26', 'label': '26 min.'},
                                        {'value': '27', 'label': '27 min.'},
                                        {'value': '28', 'label': '28 min.'},
                                        {'value': '29', 'label': '29 min.'},
                                        {'value': '30', 'label': '30 min.'},
                                        {'value': '31', 'label': '31 min.'},
                                        {'value': '32', 'label': '32 min.'},
                                        {'value': '33', 'label': '33 min.'},
                                        {'value': '34', 'label': '34 min.'},
                                        {'value': '35', 'label': '35 min.'},
                                        {'value': '36', 'label': '36 min.'},
                                        {'value': '37', 'label': '37 min.'},
                                        {'value': '38', 'label': '38 min.'},
                                        {'value': '39', 'label': '39 min.'},
                                        {'value': '40', 'label': '40 min.'},
                                        {'value': '41', 'label': '41 min.'},
                                        {'value': '42', 'label': '42 min.'},
                                        {'value': '43', 'label': '43 min.'},
                                        {'value': '44', 'label': '44 min.'},
                                        {'value': '45', 'label': '45 min.'},
                                        {'value': '46', 'label': '46 min.'},
                                        {'value': '47', 'label': '47 min.'},
                                        {'value': '48', 'label': '48 min.'},
                                        {'value': '49', 'label': '49 min.'},
                                        {'value': '50', 'label': '50 min.'},
                                        {'value': '51', 'label': '51 min.'},
                                        {'value': '52', 'label': '52 min.'},
                                        {'value': '53', 'label': '53 min.'},
                                        {'value': '54', 'label': '54 min.'},
                                        {'value': '55', 'label': '55 min.'},
                                        {'value': '55', 'label': '55 min.'},
                                        {'value': '56', 'label': '56 min.'},
                                        {'value': '57', 'label': '57 min.'},
                                        {'value': '58', 'label': '58 min.'},
                                        {'value': '59', 'label': '59 min.'},
                                    ]" />
                            </div>
                        </div>
                    </div>
                    <div class="grid__item desktop--8">
                        <div class="field--checkbox field--checkbox--inline">
                            <input
                                type="checkbox"
                                v-model="birthTimeUnknown"
                                class="field--checkbox__input"
                                value="true"
                                id="field-birthtime-unknown">
                            <label
                                for="field-birthtime-unknown"
                                class="field--checkbox__label">{{ $t("i-dont-know-the-exact-hour") }}</label>
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="grid__item desktop--4">
                        <div
                            class="field-group"
                            role="group"
                            aria-labelledby="field-gender-group-label">

                            <label
                                id="field-gender-group-label"
                                class="field__label">{{ $t("gender") }}</label>

                            <div
                                class="field--radio field--radio--inline"
                                :class="(error.errors !== undefined && error.errors['gender'] !== undefined && error.errors['gender'].length > 0) ? 'field--radio--error': ''">
                                <input
                                    required
                                    :data-label="$t('gender')"
                                    name="gender"
                                    type="radio"
                                    value="M"
                                    v-model="gender"
                                    class="field--radio__input"
                                    id="field-gender-male"
                                    aria-labelledby="field-gender-group-label field-gender-male-label">
                                <label
                                    id="field-gender-male-label"
                                    for="field-gender-male"
                                    class="field--radio__label">{{ $t("man") }}</label>
                            </div>
                            <div
                                class="field--radio field--radio--inline"
                                :class="(error.errors !== undefined && error.errors['gender'] !== undefined && error.errors['gender'].length > 0) ? 'field--radio--error': ''">
                                <input
                                    type="radio"
                                    name="gender"
                                    value="F"
                                    v-model="gender"
                                    class="field--radio__input"
                                    id="field-gender-female"
                                    aria-labelledby="field-gender-group-label field-gender-female-label">
                                <label
                                    id="field-gender-female-label"
                                    for="field-gender-female"
                                    class="field--radio__label">{{ $t("woman") }}</label>
                            </div>
                            <p
                                id="field-error-gender"
                                v-if="error.errors !== undefined && error.errors['gender'] !== undefined && error.errors['gender'].length > 0"
                                class="field__message--error"
                            >
                                {{ error.errors['gender'][0] }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="grid__item desktop--4">
                        <div
                            class="field field--text">
                            <label
                                id="field-language-label"
                                class="field__label field--text__label"
                                for="field-language">{{ $t("language") }}</label>

                            <field-select
                                :required="true"
                                :value="language"
                                name="language"
                                id="field-language"
                                input-label-id="field-language-label"
                                @update-value="updateLanguage"
                                :options="[
                                    {'value': 'fr', 'label': $t('french')},
                                    {'value': 'en', 'label': $t('english')},
                                    {'value': 'nl', 'label': $t('dutch')}
                                ]" />

                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="grid__item desktop--4">
                        <div
                            class="field field--checkbox">
                            <input
                                name="astro"
                                type="checkbox"
                                v-model="advanceAstroUser"
                                class="field--checkbox__input"
                                value="false"
                                id="field-advance-astro-user">
                            <label
                                for="field-advance-astro-user"
                                class="field--checkbox__label">{{ $t("i-am-an-advance-astro-user") }}</label>
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="grid__item desktop--4">
                        <div
                            class="field field--text">
                            <label
                                class="field__label field--text__label"
                                for="field-email">{{ $t("email") }}</label>
                            <input
                                name="email"
                                :data-label="$t('email')"
                                v-model="email"
                                id="field-email"
                                class="field__input field--text__input"
                                :class="(error.errors !== undefined && error.errors['email'] !== undefined && error.errors['email'].length > 0) ? 'field__input--error': ''"
                                type="email"
                                readonly
                            />
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="grid__item desktop--4">

                        <div
                            class="field field--text">
                            <label
                                class="field__label field--text__label"
                                for="field-password">{{ $t("password") }}</label>
                            <input
                                name="password"
                                :data-label="$t('password')"
                                v-model="password"
                                id="field-password"
                                class="field__input field--text__input"
                                :class="(error.errors !== undefined && error.errors['password'] !== undefined && error.errors['password'].length > 0) ? 'field__input--error': ''"
                                :type="(displayPassword === false) ? 'password' : 'text'"
                            />
                            <p
                                id="field-error-password"
                                v-if="error.errors !== undefined && error.errors['password'] !== undefined && error.errors['password'].length > 0"
                                class="field__message--error"
                            >
                                {{ error.errors['password'][0] }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="grid desktop--vertical--centered">
                    <div class="grid__item desktop--4">

                        <div
                            class="field field--text">
                            <label
                                class="field__label field--text__label"
                                for="field-confirm-password">{{ $t("confirm-password") }}</label>
                            <input
                                name="confirmPassword"
                                :data-label="$t('confirm-password')"
                                v-model="confirmPassword"
                                id="field-confirm-password"
                                class="field__input field--text__input"
                                :class="(error.errors !== undefined && error.errors['confirmPassword'] !== undefined && error.errors['confirmPassword'].length > 0) ? 'field__input--error': ''"
                                :type="(displayPassword === false) ? 'password' : 'text'"
                            />
                            <p
                                id="field-error-password"
                                v-if="error.errors !== undefined && error.errors['confirmPassword'] !== undefined && error.errors['confirmPassword'].length > 0"
                                class="field__message--error"
                            >
                                {{ error.errors['confirmPassword'][0] }}
                            </p>
                        </div>
                    </div>
                    <transition name="fade">
                        <div
                            v-if="password && confirmPassword"
                            class="grid__item desktop--8">
                            <div class="field--checkbox field--checkbox--inline">
                                <input
                                    type="checkbox"
                                    v-model="displayPassword"
                                    class="field--checkbox__input"
                                    value="true"
                                    id="field-display-password">
                                <label
                                    for="field-display-password"
                                    class="field--checkbox__label">{{ $t("display-password") }}</label>
                            </div>
                        </div>
                    </transition>
                </div>

                <div class="grid">
                    <div class="grid__item desktop--4">
                        <button class="button button--primary button--fullwidth">{{ $t("validate") }}</button>
                    </div>
                </div>

                <div class="grid">
                    <div class="grid__item desktop--8">
                        <div class="user-delete-box">
                            <h2 class="title--4">{{ $t("delete-your-account") }}</h2>
                            <p v-html="$t('delete-your-account-description')"></p>
                        </div>
                    </div>
                </div>
            </form>

        </div>

        <div v-if="isLoading">
            <HorizontalBubbleLoader />
        </div>

    </div>
</template>

<script>
// @ is an alias to /src
import FieldSelect from "@/components/forms/FieldSelect.vue";
import LocationAutocomplete from "@/components/autocomplete/LocationAutocomplete.vue";

import { userEdit, getmeFirsTime, login, getUserInfo, getMeTimelineFirstTime, getMeCycleFirstTime } from "@/utils/api/usersApi.js";
import { pad, purify } from "@/utils/helpers/string.js";
import { getLocationTimeZone } from "@/utils/helpers/location.js";
import { changeLocale } from "@/utils/helpers/translation/translation.js";

import { getRangeOfYear } from "@/utils/utils.js";
import { validateForm } from "@/utils/helpers/validate-form.js";
import { cleanLocale } from "@/utils/helpers/translation/translation.js";

import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";

import { setCookie } from "@/utils/helpers/cookie";

import dayjs from "dayjs";

var utc = require("dayjs/plugin/utc");
var timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
    name: "Profile",
    components: {
        FieldSelect: FieldSelect,
        LocationAutocomplete: LocationAutocomplete,
        HorizontalBubbleLoader: HorizontalBubbleLoader,
    },
    props: {
        loggedUser: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            landingUrl: process.env.VUE_APP_LANDIND_PAGE_URL,
            isLoading: false,
            pseudo: this.loggedUser.fname,
            email: this.loggedUser.login,
            password: "",
            confirmPassword: "",
            displayPassword: false,
            firstname: "",
            lastname: "",
            gender: this.loggedUser.gender,
            birthcity: this.loggedUser.bcity,
            birthcountry: this.loggedUser.bcountry,
            timezone: this.loggedUser.timezone,
            lat: this.loggedUser.latitude,
            lng: this.loggedUser.longitude,
            birthdateDay: String(pad(dayjs(this.loggedUser.bdate).date())),
            birthdateMonth: String(pad(dayjs(this.loggedUser.bdate).month() + 1)),
            birthdateYear: String(dayjs(this.loggedUser.bdate).year()),
            birthtimeHour: String(pad(dayjs(`${this.loggedUser.bdate} ${this.loggedUser.btime}`).hour())),
            birthtimeMinute: String(pad(dayjs(`${this.loggedUser.bdate} ${this.loggedUser.btime}`).minute())),
            acceptTermsAndConditions: false,
            acceptPromotionalCommunication: false,
            totalYears: getRangeOfYear(1900, new Date().getFullYear()),
            timezoneOffset: 0,
            birthTimeUnknown: false,
            language: this.loggedUser.language,
            advanceAstroUser: this.loggedUser.astro,
            error: ""
        };
    },
    computed: {
        years() {
            let array = [];

            this.totalYears.map((year) => {
                array.push({
                    "value": year.toString(),
                    "label": year.toString()
                });
            });

            return array;
        },
        birthdate() {
            return `${this.birthdateYear}-${this.birthdateMonth}-${this.birthdateDay}`;
        },
        birthtime() {
            return `${this.birthtimeHour}:${this.birthtimeMinute}:00`;
        },
        user() {

            let birthTime = this.birthtime;
            let rating = "";

            if (this.birthTimeUnknown === true) {
                rating = "X";
            }

            // const timezoneOffsetHour = this.timezoneOffset / 3600;
            // const absoluteTimezoneOffsetHour = Math.abs(timezoneOffsetHour);
            // let timezoneOffsetSign = "";

            // if (Math.sign(timezoneOffsetHour) === -1) {
            //     timezoneOffsetSign = "-";
            // } else {
            //     timezoneOffsetSign = "+";
            // }

            // const absolutePadedTimezoneOffsetHour = pad(absoluteTimezoneOffsetHour, 2);

            const formatedTimezoneOffset = this.utcDate.format("Z");

            return {
                id: this.loggedUser.id_person,
                email: this.email,
                pseudo: this.pseudo,
                gender: this.gender,
                birthcity: this.birthcity,
                birthcountry: this.birthcountry,
                timezone: this.timezone,
                lat: this.lat,
                lng: this.lng,
                birthdate: this.birthdate,
                birthtime: birthTime,
                rating: rating,
                timezoneOffset: formatedTimezoneOffset,
                language: cleanLocale(this.language),
                astro: this.advanceAstroUser
            };
        },
        utcDate() {
            let convertedDate = dayjs.tz(`${this.birthdate} ${this.birthtime}`, this.timezone);

            return convertedDate;
        }
    },
    mounted: function() {
        // console.log(dayjs(this.loggedUser.bdate).month());
    },
    methods: {
        updateBirthdateDay(value) {
            this.birthdateDay = value;
        },
        updateBirthdateMonth(value) {
            this.birthdateMonth = value;
        },
        updateBirthdateYear(value) {
            this.birthdateYear = value;
        },
        updateBirthtimeHour(value) {
            this.birthtimeHour = value;
        },
        updateBirthtimeMinute(value) {
            this.birthtimeMinute = value;
        },
        updateLanguage(value) {
            this.language = value;
        },
        updateLocation(value) {
            if (value !== null) {
                const location = value.title.split(", ");

                this.birthcity = location[0];
                this.birthcountry = (location[2]) ? location[2] : location[1];
                this.lat = value.position.lat;
                this.lng = value.position.lng;

                getLocationTimeZone(this.lat, this.lng).then((res) => {
                    if (res.status === 200) {
                        this.timezone = res.data.Response.View[0].Result[0].Location.AdminInfo.TimeZone.id;
                        this.timezoneOffset = res.data.Response.View[0].Result[0].Location.AdminInfo.TimeZone.offset;
                    } else {
                        throw (res);
                    }
                });
            } else {
                this.birthcity = "";
                this.birthcountry = "";
                this.timezone = "";
                this.lat = "";
                this.lng = "";
                this.timezoneOffset = "";
            }
        },
        submitForm() {
            // Awfull mega condition, validation should be refactor
            // console.log("submit form", e);
            let isFormValid = validateForm(this.$el);

            if(isFormValid.value === true) {
                this.error = "";

                if (this.password === this.confirmPassword) {
                    if (this.lat && this.lng) {
                        // register the user
                        this.isLoading = true;

                        userEdit(this.user).then((res) => {
                            if (res.data.status === "ok") {
                                // retrieve first time personality
                                if (res.data.id_person) {

                                    const userId = res.data.id_person;

                                    // Init personality
                                    getmeFirsTime(userId).then((res) => {
                                        if (res.status === 200 && res.data) {
                                            this.$store.commit("userModule/setPersonality", res.data);

                                            // Silently init timeline
                                            getMeTimelineFirstTime(userId);

                                            // Silently init cycle
                                            getMeCycleFirstTime(userId);

                                            const loginInfo = {
                                                "id": userId
                                            };

                                            // Retrieve User data
                                            getUserInfo(loginInfo).then((res) => {
                                                if (res.status === 200 && res.data) {
                                                    this.$store.commit("userModule/setUser", res.data);

                                                    // Should eventually update is token
                                                    // this.$store.commit("userModule/setToken", res.data.token);

                                                    this.$notificationsBar.alert(this.$t("profile-successfully-update"), {type: "success"});

                                                    changeLocale(this.user.language);
                                                    this.isLoading = false;
                                                } else {
                                                    this.isLoading = false;
                                                    throw (res);
                                                }
                                            });

                                        } else {
                                            this.isLoading = false;
                                            throw (res);
                                        }
                                    });
                                } else {
                                    this.isLoading = false;
                                }

                            } else {
                                this.isLoading = false;
                                // Handle Error
                                this.$notificationsBar.alert(res.data.message, {type: "warning"});
                                throw (res);
                            }
                        });
                    } else {
                        this.error = {
                            "message":"the_given_data_was_invalid",
                            "errors":{
                                "birthcity": [this.$t("birthplace-should-be-a-valid-location")]
                            }
                        };

                        //Set focus to first error field for screen reader
                        if(this.error.errors !== undefined && Object.keys(this.error.errors).length > 0) {
                            let errorFieldName = Object.keys(this.error.errors)[0];
                            let errorField = document.getElementById("field-" + errorFieldName.toLowerCase());
                            if(errorField) {
                                errorField.focus();
                            }
                        }
                    }
                } else {
                    this.error = {
                        "message":"the_given_data_was_invalid",
                        "errors":{
                            "confirmPassword": [this.$t("password-doesnt-match")]
                        }
                    };

                    //Set focus to first error field for screen reader
                    if(this.error.errors !== undefined && Object.keys(this.error.errors).length > 0) {
                        let errorFieldName = Object.keys(this.error.errors)[0];
                        let errorField = document.getElementById("field-" + errorFieldName.toLowerCase());
                        if(errorField) {
                            errorField.focus();
                        }
                    }
                }


            } else {
                // There are some errors
                this.error = isFormValid.error;

                //Set focus to first error field for screen reader
                if(this.error.errors !== undefined && Object.keys(this.error.errors).length > 0) {
                    let errorFieldName = Object.keys(this.error.errors)[0];
                    let errorField = document.getElementById("field-" + errorFieldName.toLowerCase());
                    if(errorField) {
                        errorField.focus();
                    }
                }
            }
        }
    }
};
</script>

